<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" name="btns">
            <div class="left">
                <div v-if="checkActionPerm('create')" class="swb-btn swb-btn-small" @click="toPurchReceiptAdd">
                    <span>新增</span>
                </div>
            </div>
            <div class="right">
                <div v-if="checkActionPerm('create_js')" class="swb-btn swb-btn-small swb-btn-primary" @click="toCreateJS(null)">
                    <span>生成结算单</span>
                </div>
            </div>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
import {Utils, $} from '../../app.base'
import {Vue, MsgBox, Routes, DomSizeWatcher} from '../../app.vues'
import {getDefaultPageSizes} from '../../app.conf'
import {checkUserActionPerm} from '../index'
import {
    openPurchReceiptManualSaveDlg,
    openPurchReceiptDetailDlg,
    openPurchReceiptSettleProofSaveDlg
} from './showDlg'
import {openAssetDeprAdjustVoucherSaveDlg} from '../assetFiscal/showDlg'
import {openAuditDlg} from '../bizUnion/selectDlg';
import {getMerchtAuditBpConfInfo, openOaAuditBpNodeDlg} from '../oaAudit/selectDlg'
import {showComActionPostSelectDlg} from '../merchant/showSelectDlg'
import {openApplyDescDlg} from '../bizUnion/selectDlg'

import receiptApi from '../../api/receipt'
import contractApi from '../../api/contract'
import userApi from '../../api/user'
import assetFiscalApi from '../../api/assetFiscal'
import fiscalProofApi from '../../api/fiscalProof'
import oaAuditApi from '../../api/oaAudit'

import SwbPurchReceiptAudit from './PurchReceiptAudit';

Vue.regist(SwbPurchReceiptAudit);

export default {
    name: 'swb-purch-receipt-manual-list',
    path: '/purch/receipt/manual/list/get',
    desc: '费用验收单管理',
    data: function () {
        return {
            // 分页信息
            pageNumber: 1,
            totalCount: 0,
            pageSize: null,
            pageSizes: getDefaultPageSizes(),
            //
            confKey: 'swb-purch-receipt-manual-list',
            theTableHeight: 300,
            //
            needPager: true, //是否需要分页（默认：true）
            multiSelect: true, //是否多选（默认：false）
            multiPageSelect: true, //是否要多页/跨页选择（默认：false）
            rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
            rowNoShow: false, //是否显示行号（默认：true）
            rowNoFixed: false, //行号列是否固定（默认：false）
            //
            btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
            btnColTitle: '操作',//操作列标题（默认：'操作'）
            btnColWidth: 200,//操作列宽度（默认：100）
            btnColFixed: true, //操作列是否固定
            // 过滤信息
            queryKey: null,
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {}
            },
            // 其他信息
            purchReceiptList: [],
            taxPayTypeMap: getEnumMap("taxPayType", "value2text"),
            orderTypeMap: getEnumMap("orderType", "value2text"),
            srcVoucherTypeMap: getEnumMap("devcVoucherType", "value2text"),
            deprAdjustTypeVal: getEnumInfoWith('devcVoucherType', 'name', 'DeprAdjust').value, // 折旧调整单据类型
            ledgerStatePjenerating: getEnumInfoWith('ledgerState', 'name', 'Pjenerating').value, // 生凭中
            ledgerStatePjRecvDone: getEnumInfoWith('ledgerState', 'name', 'PjRecvDone').value, // 接受完毕，对方单据已返回
            ledgerStatePjPushDone: getEnumInfoWith('ledgerState', 'name', 'PjPushDone').value, // 推送成功，对方单据已返回
            ledgerStateMap: getEnumMap('ledgerState', 'value2text'),
            postId: null,
            contractNo: null,
            orderNo: null,
            no: null,
            innerNo: null,
            settleStateMpas: getEnumMap('settleState', 'value2text'),
            isAuditBpConfAvailable: false,
            needAssignAuditors: false,
        }
    },
    created: function () {
        this.pageSize = this.pageSizes.first();
        //
        let trunsFlag = Utils.isTrue(this.$route.query.trunsFlag);
        if (Utils.isTrue(trunsFlag)) {
            let contractFlag = Utils.isTrue(this.$route.query.contractFlag);
            let contractNo = this.$route.query.contractNo || null;
            let orderNo = this.$route.query.orderNo || null;
            let no = this.$route.query.no || null;
            if (Utils.isTrue(contractFlag)) {
                // 从合同跳转
                if (!Utils.isNoB(contractNo)) {
                    this.contractNo = contractNo;
                }
                if (!Utils.isNoB(orderNo)) {
                    this.orderNo = orderNo;
                }
            } else if (!Utils.isNoB(orderNo)) {
                this.orderNo = orderNo;
            } else if (!Utils.isNoB(no)) {
                this.no = no;
            }
        }
        //
        this.innerNo = this.$route.query.innerNo || null;
        if (!Utils.isNoB(this.innerNo)) {
            this.queryModel.filterItems.innerNo = this.innerNo;
        }
        //
        this.isMerchtAuditBpConfAvailable();
        this.getCurrentUserInfo();
        //
        let self = this;
        getMerchtAuditBpConfInfo("retailer.assets.purch.receipt", true, function (auditBpConfInfo) {
            self.needAssignAuditors = Utils.isTrue(auditBpConfInfo.needAssignAuditors);
        });
    },
    mounted() {
        let self = this;
        //注册domSizeWatcher
        let thisEl = $(this.$el);
        $(this.$el).addClass('overflow-hidden');
        //
        let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
        domSizeWatcher.setBaseEl(thisEl);
        domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
            //根据新主元素的内容大小，调整表格高度
            self.theTableHeight = height;
        });
        //domSizeWatcher.setHrEls();
        domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], [name="btns"]'));
        domSizeWatcher.start(500);
        //
        this.initResultTable();
    },
    destroyed() {
        //释放domSizeWatcher
        let domSizeWatcher = this.domSizeWatcher;
        if (domSizeWatcher != null) {
            domSizeWatcher.clear();
            this.domSizeWatcher = null;
        }
    },
    methods: {
        isMerchtAuditBpConfAvailable: function () {
            let self = this;
            oaAuditApi.isMerchtAuditBpConfAvailable({bizTypeCode: 'retailer.assets.allot'}, function (result) {
                if (result.type == 'info') {
                    self.isAuditBpConfAvailable = Utils.isTrue(result.data);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getCurrentUserInfo: function () {
            let self = this;
            let data = {};
            userApi.getUserInfoByContext(data, function (result) {
                if (result.type === "info") {
                    let userInfo = result.data || {};
                    let scopeEntity = userInfo.scopeEntity || {};
                    self.postId = scopeEntity.postId;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        onQueryConfigReady: function () {
            // 纳税类型
            let taxPayTypeList = getEnumList("taxPayType") || [];
            let dataList = [];
            dataList.push({"value": null, "label": "-全部-"});
            taxPayTypeList.forEach(function (item) {
                dataList.push({
                    value: item.value,
                    label: item.text
                });
            });
            this.updateQueryModelField("buyerTaxPayType", dataList);
            this.updateQueryModelField("sellerTaxPayType", dataList);
            // 订单类型
            let orderTypeList = getEnumList("orderType") || [];
            dataList = [];
            dataList.push({"value": null, "label": "-全部-"});
            orderTypeList.forEach(function (item) {
                if (item != null && item.name == 'GoodsOrder') {
                    dataList.push({
                        value: item.value,
                        label: item.text
                    });
                }
            });
            this.updateQueryModelField("orderType", dataList);
            //
            if (!Utils.isNoB(this.contractNo)) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {value: this.contractNo};
                let fieldInfo = {};
                fieldInfo["contractNo"] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
            if (!Utils.isNoB(this.orderNo)) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {value: this.orderNo};
                let fieldInfo = {};
                fieldInfo["orderNo"] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
            if (!Utils.isNoB(this.innerNo)) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {value: this.innerNo};
                let fieldInfo = {};
                fieldInfo["innerNo"] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
            // 生凭状态
            dataList = [];
            dataList = [{"value": null, "label": "- 全部 -"}];
            let ledgerStateList = getEnumList("ledgerState");
            ledgerStateList.forEach(function (item) {
                let ledgerState = {};
                ledgerState.value = item.value;
                ledgerState.label = item.text;
                dataList.push(ledgerState);
            });
            let revokeItem = {"value": 100, "label": "已冲销"};
            dataList.push(revokeItem);
            this.updateQueryModelField("ledgerState", dataList);
        },
        updateQueryModelField: function (itemCode, dataList = []) {
            if (itemCode != null) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {dataList: dataList};
                let fieldInfo = {};
                fieldInfo[itemCode] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
        },
        initResultTable() {
            let self = this;
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let resultTable = this.$refs['result_table'];
            //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
            resultTable.setQrySortRef(query_model_ctrl);
            //
            resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                'buyerTaxPayType': function (row, colName, colValue, rowIndex, colConf) {
                    return "<span>" + self.taxPayTypeMap[row.buyerTaxPayType] + "</span>";
                },
                'sellerTaxPayType': function (row, colName, colValue, rowIndex, colConf) {
                    return "<span>" + self.taxPayTypeMap[row.sellerTaxPayType] + "</span>";
                },
                'orderType': function (row, colName, colValue, rowIndex, colConf) {
                    if (row.orderType != 0) {
                        return "<span>" + self.orderTypeMap[row.orderType] + "</span>";
                    }
                },
                'srcVoucherType': function (row, colName, colValue, rowIndex, colConf) {
                    return "<span>" + self.srcVoucherTypeMap[row.srcVoucherType] + "</span>";
                },
                'settleProofId': function (row, colName, colValue, rowIndex, colConf) {
                    if (row.settleProofId == -1) {
                        return "<span>否</span>";
                    } else {
                        return "<span>是</span>";
                    }
                },
                'settleState': function (row, colName, colValue, rowIndex, colConf) {
                    return '<span>' + self.settleStateMpas[row.settleState] + '</span>';
                },
                'fiscalAcctState': function (row, colName, colValue, rowIndex, colConf) {
                    if (row.fiscalAcctState == 0) {
                        return "<span>未入账</span>";
                    } else if (row.fiscalAcctState == 1) {
                        return "<span>部分入账</span>";
                    } else if (row.fiscalAcctState == 2) {
                        return "<span>全部入账</span>";
                    }
                },
                'auditState': function (row, colName, colValue, rowIndex, colConf) {
                    if (row.auditState == 0) {
                        return "<span>待审核</span>";
                    } else if (row.auditState == 1) {
                        return "<span>审核通过</span>";
                    }
                },
                'backConfirmFlag': function (row, colName, colValue, rowIndex, colConf) {
                    if (row.backConfirmFlag == 0) {
                        return "<span>未确认</span>";
                    } else if (row.backConfirmFlag == 1) {
                        return "<span>已确认</span>";
                    } else if (row.backConfirmFlag == -1) {
                        return "<span>无需确认</span>";
                    }
                },
                // 生凭状态
                'ledgerState': function (row, colName, colValue, rowIndex) {
                    if (Utils.isTrue(row.fiscalRevoked)) {
                        return '<span class="font-red">已冲销</span>';
                    } else {
                        return '<span>' + self.ledgerStateMap[row.ledgerState] + '</span>';
                    }
                },
                'actions': function (row, colName, colValue, rowIndex) {
                    let btnList = [];
                    if (self.checkActionPerm('view_detail')) {
                        btnList.push({
                            name: 'view_detail',
                            text: '详情'
                        });
                    }
                    //  && row.ledgerState == self.ledgerStatePjRecvDone
                    if (self.checkActionPerm('audit') && !row.invalid && row.auditState == 0 && (row.backConfirmPostId == -1 || row.backConfirmPostId == self.postId)) {
                        btnList.push({
                            name: 'audit',
                            text: '确认' // 回溯确认就是审核操作，回溯确认==》确认（2021-06-07）
                        });
                    }
                    //  && row.ledgerState == self.ledgerStatePjRecvDone
                    if (self.checkActionPerm('create_js') && !row.pulledBack && row.pulledBackApplyState != 1 && row.pulledBackAuditState != 1 && !row.invalid && row.settleProofId == -1 && row.auditState == 1 && row.settleState != -2 && row.settlable) {
                        btnList.push({
                            name: 'create_js',
                            text: '结算'
                        });
                    }
                    // @lcj 零售商：验收单（临采。购置、费用）调拨、报废、调整、结算等业务中的凭证冲销注释掉（前端代码去除掉）
                    // if (self.checkActionPerm('proof_revoked') && !row.pulledBack && row.pulledBackApplyState != 1 && row.pulledBackAuditState != 1 && !row.invalid && row.ledgerState == self.ledgerStatePjRecvDone && !row.fiscalRevoked) {
                    //     btnList.push({
                    //         name: 'proof_revoked',
                    //         text: '凭证冲销'
                    //     });
                    // }
                    if (self.checkActionPerm('newFiscalProof') && !row.invalid && ((row.ledgerState > self.ledgerStatePjenerating && row.ledgerState < self.ledgerStatePjRecvDone) || (row.ledgerState == self.ledgerStatePjRecvDone && row.fiscalRevoked))) {
                        btnList.push({
                            name: 'newFiscalProof',
                            text: '重新生凭'
                        });
                    }
                    if (self.checkActionPerm('do_reject') && !row.pulledBack && !row.invalid && (row.pullBackNo == null || row.pullBackNo == '') && (row.settleProofId == null || row.settleProofId == -1) && row.auditState == 1) {
                        btnList.push({
                            name: 'do_reject',
                            text: '业务冲销'
                        });
                    }
                    if (self.checkActionPerm('do_pulledBack_apply') && !row.pulledBack && !row.invalid && (row.pullBackNo != null && row.pullBackNo != '' && row.pulledBackApplyState != 1 && row.pulledBackAuditState != 1) && (row.settleProofId == null || row.settleProofId == -1) && row.auditState == 1) {
                        btnList.push({
                            name: 'do_pulledBack_apply',
                            text: '业务冲销申请'
                        });
                    }
                    if (self.checkActionPerm('do_pulledBack_audit', row.pulledBackAuditorPostId) && !row.pulledBackOuterAuditFlag && !row.pulledBack && !row.invalid && row.auditState == 1 && row.pullBackNo != null && row.pullBackNo != '' && !row.pulledBack && row.pulledBackApplyState == 1 && row.pulledBackAuditState == 0) {
                        btnList.push({
                            name: 'do_pulledBack_audit',
                            text: '业务冲销审核'
                        });
                    }
                    // && (row.settleProofId == null || row.settleProofId == -1)
                    if (self.checkActionPerm('do_invalid') && !row.invalid && row.auditState != 1) {
                        btnList.push({
                            name: 'do_invalid',
                            text: '作废'
                        });
                    }
                    // 全部入账 -- 结算单未审核通过  && row.ledgerState == self.ledgerStatePjRecvDone  (row.srcVoucherType == 1 资产购置)
                    if (self.checkActionPerm('depr_adjust') && !row.pulledBack && row.pulledBackApplyState == null && !row.invalid && !row.alterFlag && !Utils.isTrue(row.hasDeprAdjust) && row.fiscalAcctState == 2 && !row.settleVoucherAuditPass && row.srcVoucherType == 1) {
                        btnList.push({
                            name: 'depr_adjust',
                            text: '调整'
                        });
                    }
                    if (self.checkActionPerm('create_voucher') && row.pulledBack && row.invalid && row.newReceiptId == null && (row.srcVoucherType == self.deprAdjustTypeVal && !row.adjustPullBackFlag || row.srcVoucherType != self.deprAdjustTypeVal)) {
                        btnList.push({
                            name: 'create_voucher',
                            text: '重新生成'
                        });
                    }
                    return btnList;
                }
            }, /* 单元格按钮点击处理函数 */{
                //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                'actions': function (row, colName, colValue, rowIndex, btnName) {
                    if (btnName == 'view_detail') {
                        self.viewPurchReceipt(row.id, row.alterFlag);
                    } else if (btnName == 'create_js') {
                        self.toCreateJS(row);
                    } else if (btnName == 'audit') {
                        self.toAudit(row);
                    } else if (btnName == 'depr_adjust') {
                        self.createDeprAdjustVoucher(row);
                    } else if (btnName == 'proof_revoked') {
                        // 凭证冲销
                        self.proofRevoked(row.id);
                    } else if (btnName == 'newFiscalProof') {
                        // 重新生凭
                        self.newFiscalProof(row);
                    } else if (btnName == 'do_reject') {
                        // 业务冲销
                        self.doRejectPurchReceipt(row);
                    } else if (btnName == 'do_pulledBack_apply') {
                        // 业务冲销申请
                        self.doApplyPurchReceiptReject(row, null, true);
                    } else if (btnName == 'do_pulledBack_audit') {
                        // 业务冲销审核
                        self.doAuditPurchReceiptReject(row);
                    } else if (btnName == 'do_invalid') {
                        // 作废
                        self.doInvalidPurchReceipt(row);
                    } else if (btnName == 'create_voucher') {
                        self.createNewVoucher(row);
                    }
                }
            });
        },
        checkActionPerm: function (action, targetPostId) {
            return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
        },
        //
        queryHandler: function (queryModel) {
            this.queryModel = queryModel;
            this.pageNumber = 1;
            this.getPurchReceiptPagedList();
        },
        //
        pageNoChangeHandler: function (pageNumber, pageSize) {
            this.pageSize = pageSize;
            this.pageNumber = pageNumber;
            //
            this.getPurchReceiptPagedList();
        },
        renderTable(rows, pagination) {
            //
            let resultTable = this.$refs.result_table;
            //清除数据（如果已经渲染的数据与新的列不是一回事儿）
            //resultTable.clear();
            //同步使用新的自定义列信息
            //resultTable.initMeta(confColList);
            //设置新数据
            let tableData = {
                rows: rows,
                pagination: pagination
            };

            resultTable.render(tableData);
        },
        getPurchReceiptPagedList() {
            let self = this;
            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber,
            };
            //
            let queryModel = self.queryModel;
            let filterItems = Utils.merge({}, queryModel.filterItems);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            //
            filterItems.directFlag = getEnumInfoWith("directFlag", "name", "Forward").value;
            filterItems.deriveFalg = false;
            filterItems.manualFlag = true;
            //
            if (!Utils.isNoB(filterItems.ledgerState) && filterItems.ledgerState == 100) {
                filterItems.ledgerState = null;
                filterItems.fiscalRevoked = true;
            }
            if (!Utils.isNoB(this.no)) {
                filterItems.no = this.no;
            }
            //
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            //
            let theLoading = MsgBox.loading();
            // 调用查询接口
            receiptApi.getPurchReceiptList(postData, function (result) {
                theLoading.close();
                if (result.type == 'info') {
                    self.purchReceiptList = result.data.rows;
                    self.totalCount = result.data.pagination.totalCount;
                    self.renderTable(self.purchReceiptList, result.data.pagination);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 新增调整单
        createDeprAdjustVoucher: function (row) {
            let self = this;
            let receiptId = row.id;
            //
            let itemList = row.itemList || [];
            let deviceXIds = itemList.pluck('deviceXId');
            if (itemList.length == 0) {
                MsgBox.warning("无验收项-请确认");
                return;
            }
            openAssetDeprAdjustVoucherSaveDlg({
                receiptId: receiptId,
                deviceXIds: deviceXIds,
                mulitiWorth: false
            }, function (deprAdjustVoucher, theSaveDlg) {
                let itemList = deprAdjustVoucher.itemList || [];
                let errMsg = "";
                if (itemList.length > 0) {
                    for (let i = 0; i < itemList.length; i++) {
                        let item = itemList[i];
                        if (!Utils.isTrue(item.isChangeFlag)) {
                            errMsg = "有未调整的资产，请调整或者移除！";
                            break;
                        }
                    }
                }
                if (Utils.isNoB(errMsg)) {
                    let loading = MsgBox.loading();
                    deprAdjustVoucher.purchReceiptId = receiptId;
                    console.log(deprAdjustVoucher);
                    assetFiscalApi.saveAssetDeprAdjustVoucher(deprAdjustVoucher, function (result) {
                        loading.close();
                        if (result.type == "info") {
                            //
                            theSaveDlg.close();
                            MsgBox.success("调整成功");
                            //
                            self.getPurchReceiptPagedList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    let newItemList = [];
                    for (let i = 0; i < itemList.length; i++) {
                        let item = itemList[i];
                        if (Utils.isTrue(item.isChangeFlag)) {
                            newItemList.add(item);
                        }
                    }
                    if (newItemList.length <= 0) {
                        MsgBox.warning("至少调整一个");
                        return;
                    }
                    deprAdjustVoucher.itemList = Utils.merge([], newItemList);
                    console.log(deprAdjustVoucher);
                    self.$confirm('有未调整的资产，是否继续？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        let loading = MsgBox.loading();
                        deprAdjustVoucher.purchReceiptId = receiptId;
                        assetFiscalApi.saveAssetDeprAdjustVoucher(deprAdjustVoucher, function (result) {
                            loading.close();
                            if (result.type == "info") {
                                //
                                theSaveDlg.close();
                                MsgBox.success("调整成功");
                                //
                                self.getPurchReceiptPagedList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }).catch(function () {
                    });
                }
            });
        },
        // 查看详情
        viewPurchReceipt: function (id, alterFlag) {
            let params = {
                id: id
            };
            openPurchReceiptDetailDlg(params);
        },
        // 新增验收单
        toPurchReceiptAdd: function () {
            let self = this;
            let params = {};
            openPurchReceiptManualSaveDlg(params, function (result) {
                //
                if (!Utils.isNoB(result)) {
                    MsgBox.success('保存成功!');
                    self.pageNumber = 1;
                    self.getPurchReceiptPagedList();
                }
            });
        },
        getTableSelection() {
            let resultTable = this.$refs.result_table;
            return resultTable.getSelection();
        },
        toCreateJS(currentRow) {
            let self = this;
            let selectList = this.getTableSelection() || [];
            if (!Utils.isNoB(currentRow)) {
                selectList = [currentRow];
            }
            if (selectList == null || selectList.length <= 0) {
                MsgBox.warning('请选择要操作的数据');
                return;
            }
//                生凭和结算无关，不做控制 2021-03-17
            let buyerRealComCode = selectList[0].buyerRealComCode;
            let invoiceType = selectList[0].invoiceType;
            let contractId = selectList[0].contractId;
            let tempFlag = selectList[0].tempFlag;
            let sellerId = selectList[0].sellerId;
            let sellerType = selectList[0].sellerType;
            let sellerRealId = selectList[0].sellerRealId;
            for (let i = 0; i < selectList.length; i++) {
                if (Utils.isTrue(selectList[i].invalid)) {
                    MsgBox.warning('【' + selectList[i].innerNo + '】已作废不可结算');
                    return;
                }
                if (selectList[i].auditState != 1) {
                    MsgBox.warning('【' + selectList[i].innerNo + '】未审核通过不可结算');
                    return;
                }
                if (selectList[i].settleProofId != -1) {
                    MsgBox.warning('【' + selectList[i].innerNo + '】不可重复结算');
                    return;
                }
                if (selectList[i].settleState == -2) {
                    MsgBox.warning('【' + selectList[i].innerNo + '】无需结算');
                    return;
                }
                if (selectList[i].settlable == false) {
                    MsgBox.warning('【' + selectList[i].innerNo + '】不可结算');
                    return;
                }
                if (selectList[i].tempFlag != tempFlag || selectList[i].sellerType != sellerType) {
                    MsgBox.warning('不可跨卖家结算');
                    return;
                }
                if (tempFlag) {
                    if (selectList[i].sellerId != sellerId) {
                        MsgBox.warning('不可跨卖家结算');
                        return;
                    }
                } else {
                    if (selectList[i].sellerRealId != sellerRealId) {
                        MsgBox.warning('不可跨卖家结算');
                        return;
                    }
                }
                if (selectList[i].contractId != contractId) {
                    MsgBox.warning('不可跨合同结算');
                    return;
                }
                if (selectList[i].buyerRealComCode != buyerRealComCode) {
                    MsgBox.warning('不可跨实体公司结算');
                    return;
                }
                if (selectList[i].invoiceType != invoiceType) {
                    MsgBox.warning('不可跨发票类型结算');
                    return;
                }
            }
            if (contractId != -1) {
                this.getContractInfo(contractId, function (contract) {
                    self.showCreateJS(selectList, contract);
                });
            } else {
                this.showCreateJS(selectList);
            }
        },
        getContractInfo: function (contractId, callback) {
            let postData = {
                id: contractId
            };
            let theLoad = MsgBox.loading();
            contractApi.getContractInfo(postData, function (result) {
                theLoad.hide();
                if (result.type == "info") {
                    callback(result.data);
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        showCreateJS(purchReceiptList, contract) {
            let self = this;
            let params = {
                purchReceiptList: purchReceiptList,
                returnFalg: false,
                contract: contract
            };
            openPurchReceiptSettleProofSaveDlg(params, function (result) {
                self.getPurchReceiptPagedList();
                //
                let resultTable = self.$refs['result_table'];
                resultTable.setInitChecked([]);
            });
        },
        toAudit(row) {
            let self = this;
            let theDlg = Vue.$showDialog({
                title: "验收单-审核",
                width: -100,
                height: -50,
                showCloseBtn: true,
                confirmText: '审核通过',
                template: '<swb-purch-receipt-audit :purchReceipt="purchReceipt" ref="swb_purch_receipt_audit"></swb-purch-receipt-audit>',
                data: {
                    purchReceipt: row
                },
                okClicked: function () {
                    let result = this.$refs.swb_purch_receipt_audit.getDlgResult();
                    if (result.type == 'info') {
                        self.$confirm('请您确认是否验收?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(function () {
                            let postData = result.data || {};
                            let theLoading = MsgBox.loading();
                            receiptApi.doAuditPurchReceipt(postData, function (result) {
                                theLoading.close();
                                if (result.type == 'info') {
                                    theDlg.close();
                                    MsgBox.success('操作成功');
                                    self.getPurchReceiptPagedList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }).catch(function () {
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                    return false;
                }
            });
        },
        // 冲销
        proofRevoked: function (bizVoucherId) {
            let self = this;
            this.$confirm('确定要进行凭证冲销吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let postData = {
                    bizVoucherId: bizVoucherId,
                    sysBizTypeCode: getEnumInfoWith('sysBizType', 'name', 'ASSET_PURCH').code
                };
                let theLoad = MsgBox.loading();
                fiscalProofApi.updateFiscalBizProofForRevokedByBizVoucherId(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        MsgBox.success("操作成功");
                        //
                        setTimeout(function () {
                            self.getPurchReceiptPagedList();
                        }, 500);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }).catch(function () {
            });
        },
        // 重新生凭
        newFiscalProof: function (row) {
            let self = this;
            this.$confirm('确定要重新生凭吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let postData = {
                    bizVoucherId: row.id,
                    bizVoucherNo: row.no,
                    sysBizTypeCode: getEnumInfoWith('sysBizType', 'name', 'ASSET_PURCH').code
                };
                let theLoading = MsgBox.loading();
                fiscalProofApi.doRebuildCreateFiscalProofByBizVoucherId(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        MsgBox.success("操作成功");
                        setTimeout(function () {
                            self.getPurchReceiptPagedList();
                        }, 500);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }).catch(function () {
            });
        },
        // 业务冲销
        doRejectPurchReceipt: function (row) {
            let self = this;
            //
            let postData = {
                id: row.id
            };
            // 没有对接点或者不选人，指定审核岗
            if (!Utils.isTrue(self.isAuditBpConfAvailable) || !self.needAssignAuditors) {
                //
                showComActionPostSelectDlg({
                    title: '验收单冲销 - 指定审核岗',
                    rescUrl: Vue.$getClassInfo(this).path,
                    action: 'do_pulledBack_audit',
                    initPostId: row.pulledBackAuditorPostId,
                    useParents: true,
                    descLabel: '冲销原因',
                    applyDesc: row.rejectCause
                }, function (resultData) {
                    resultData = resultData || {};
                    if (resultData.postId == null) {
                        Toast.show('请选择审核岗位', 3000, 'warning');
                        return false;
                    }
                    //
                    postData.rejectCause = resultData.applyDesc;
                    receiptApi.doPullBackPurchReceiptById(postData, function (result) {
                        if (result.type == 'info') {
                            // 申请
                            self.doApplyPurchReceiptReject(row, resultData.postId, false);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }, this);
            } else {
                // 需要选人，填写冲销原因
                openApplyDescDlg(function (ruleForm) {
                    let applyDesc = null;
                    if (!Utils.isNoB(ruleForm)) {
                        applyDesc = ruleForm.desc || '';
                    }
                    postData.rejectCause = applyDesc;
                    receiptApi.doPullBackPurchReceiptById(postData, function (result) {
                        if (result.type == 'info') {
                            // 申请
                            self.doApplyPurchReceiptReject(row, null, false);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }, "冲销原因");
            }
        },
        // 业务冲销申请
        doApplyPurchReceiptReject: function (row, postId, needSelectPost) {
            let self = this;
            if (self.needAssignAuditors) {
                needSelectPost = false;
            }
            //
            let postData = {
                id: row.id
            };
            if (Utils.isTrue(needSelectPost)) {
                showComActionPostSelectDlg({
                    title: '验收单冲销 - 指定审核岗',
                    rescUrl: Vue.$getClassInfo(this).path,
                    action: 'audit',
                    initPostId: row.pulledBackAuditorPostId,
                    useParents: true,
                    descLabel: '冲销原因',
                    applyDesc: row.rejectCause
                }, function (resultData) {
                    resultData = resultData || {};
                    if (resultData.postId == null) {
                        Toast.show('请选择审核岗位', 3000, 'warning');
                        return false;
                    }
                    //
                    postData.pulledBackAuditorPostId = resultData.postId;
                    postData.rejectCause = resultData.applyDesc;
                    let theLoading = MsgBox.loading();
                    receiptApi.doApplyPurchReceiptPullBack(postData, function (resultX) {
                        theLoading.close();
                        if (resultX.type == 'info') {
                            MsgBox.success("操作成功");
                            self.getPurchReceiptPagedList();
                        } else {
                            MsgBox.warning(resultX.message);
                        }
                    });
                }, this);
            } else {
                //
                if (self.needAssignAuditors) {
                    let params = {
                        bizTypeCode: 'retailer.assets.purch.receipt',
                        bizVoucherNo: row.innerNo || row.no,
                        auditSeqNo: row.auditSeqNo
                    };
                    openOaAuditBpNodeDlg(params, function (auditorList, theDlg) {
                        auditorList = auditorList || [];
                        if (auditorList.length <= 0) {
                            MsgBox.warning("无审批人员信息");
                            return;
                        }
                        theDlg.close();
                        //
                        postData.auditorList = Utils.merge([], auditorList);
                        let theLoading = MsgBox.loading();
                        receiptApi.doApplyPurchReceiptPullBack(postData, function (resultX) {
                            theLoading.close();
                            if (resultX.type == 'info') {
                                MsgBox.success("操作成功");
                                self.getPurchReceiptPagedList();
                            } else {
                                MsgBox.warning(resultX.message);
                            }
                        });
                    });
                } else {
                    postData.pulledBackAuditorPostId = postId;
                    let theLoading = MsgBox.loading();
                    receiptApi.doApplyPurchReceiptPullBack(postData, function (resultX) {
                        theLoading.close();
                        if (resultX.type == 'info') {
                            MsgBox.success("操作成功");
                            self.getPurchReceiptPagedList();
                        } else {
                            MsgBox.warning(resultX.message);
                        }
                    });
                }
            }
        },
        // 业务冲销审核
        doAuditPurchReceiptReject: function (row) {
            let self = this;
            //
            openAuditDlg(row, function (result) {
                if (!Utils.isNoB(result)) {
                    let postData = {
                        id: row.id,
                        pullBackNo: row.pullBackNo,
                        auditState: result.resource,
                        auditDesc: result.desc
                    };
                    let theLoading = MsgBox.loading();
                    receiptApi.doAuditPurchReceiptPullBack(postData, function (result) {
                        theLoading.close();
                        if (result.type == 'info') {
                            if (row.srcVoucherType == 15) {
                                MsgBox.success('业务冲销不会产生财务凭据，请根据来源单号，及时进行业务冲销；以便保证资产原值与结算金额一致')
                            } else {
                                MsgBox.success("操作成功");
                            }
                            self.getPurchReceiptPagedList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            });
        },
        // 业务冲销作废
        doInvalidPurchReceipt: function (row) {
            let self = this;
            this.$prompt('确定要作废吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPlaceholder: '作废原因',
            }).then(({value}) => {
                let postData = {
                    id: row.id,
                    invalidCause: value
                };
                //
                let theLoading = MsgBox.loading();
                receiptApi.doInvalidPurchReceiptById(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        MsgBox.success("操作成功");
                        self.getPurchReceiptPagedList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }).catch(function () {
            });
        },
        createNewVoucher: function (row) {
            let self = this;
            this.$confirm('确定要重新创建吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let postData = {
                    id: row.id,
                };
                let theLoading = MsgBox.loading();
                receiptApi.doCreatePurchReceipt(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        MsgBox.success("操作成功");
                        self.getPurchReceiptPagedList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }).catch(function () {
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/receipt/PurchReceiptManualList.vue